import { LayoutContext } from 'dataLayer/LayoutContext';
import Head from 'next/head';
import { FC, useContext } from 'react';

export type LayoutProps = {
  children: React.ReactNode;
};

const PublicLayout: FC<LayoutProps> = ({ children }) => {
  const { title } = useContext(LayoutContext);
  return (
    <>
      <Head>
        <title>{`${title ? title + ' - ' : ''}Visto`}</title>
      </Head>
      <main className="min-h-screen bg-body">{children}</main>
    </>
  );
};

export default PublicLayout;
